module.exports = __webpack_public_path__ + "img/Run.031dc6f9.svg";